import { FileType } from "core";
export const getFileType = (extension: string): FileType => {
  const AudioExtensions = ["mp3", "mp4", "wav", "ogg", "mp4", "aac", "webm"];
  if (AudioExtensions.includes(extension.toLowerCase())) {
    return FileType.Audio;
  }
  return FileType.Image;
};
